module.exports = __webpack_public_path__ + "img/the-philosophy-of-perception-cover.195bc59d.jpg";